/**
 * Safely parse alternatives from the API response.
 *
 * The DB stores alternatives as a JSON-stringified string (Prisma String? column).
 * The API returns the raw Prisma value without parsing, so the frontend may receive:
 *   - null / undefined  (no alternatives recorded)
 *   - string[]          (already parsed — future-proofing if the API is fixed)
 *   - JSON string       (e.g. '["Redux","Zustand"]')
 *   - empty string      (edge case)
 *
 * This helper normalises all of the above into a plain string[].
 */
export function parseAlternatives(
  alternatives: string[] | string | null | undefined,
): string[] {
  if (!alternatives) return [];
  if (Array.isArray(alternatives))
    return alternatives.filter((item): item is string => typeof item === "string");
  if (typeof alternatives === "string") {
    try {
      const parsed: unknown = JSON.parse(alternatives);
      if (!Array.isArray(parsed)) return [];
      return parsed.filter((item): item is string => typeof item === "string");
    } catch {
      return [];
    }
  }
  return [];
}
